import { useAuth0 } from '@auth0/auth0-react';
import {
    Box,
    Button,
    LinearProgress,
    linearProgressClasses,
    styled,
    Typography,
} from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { schoolPreBookingUpload } from '../../redux/BookingSlice';
import LimitedTextField from '../BasicComponents/LimitedTextField';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    margin: '8px',
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.primary.light,
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.primary.main,
    },
}));

const BookingButton = styled(Button)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

export const SchoolApproved = props => {
    const dispatch = useDispatch();
    // const classes = useStyles();
    const { getAccessTokenSilently } = useAuth0();

    const [documents, setDocuments] = useState([]);
    const [progress, setProgress] = useState({ loaded: 0, total: 0 });

    const [state, setState] = useState({
        textToUpload: '',
        uploadingState: 'Awaiting submit',
        schoolPreBookingUpload: 'incomplete',
        error: false,
        errorText: '',
    });

    const fileSelectHandler = event => {
        console.log(event.target.files);
        setDocuments(event.target.files);
    };

    const bookingText = event => {
        if (event.target.value !== '') {
            setState({
                ...state,
                textToUpload: event.target.value,
                error: false,
                errorText: '',
            });
        } else {
            setState({
                ...state,
                textToUpload: event.target.value,
                error: true,
                errorText: 'Please enter some information',
            });
        }
    };
    const handleSubmission = async () => {
        //Logic needed, if documents array > 0 in length dont send document

        //If logic is needed to store localStorage data locally before submitting use the following
        // localStorage.setItem('preshiftdocuments.text', state.textToUpload);
        // const token = await getAccessTokenSilently({
        //     scope: process.env.REACT_APP_scope,
        // });
        // const preshiftdocumentsText = localStorage.getItem('preshiftdocuments.text');
        // setState({
        //     ...state,
        //     textToUpload: preshiftdocumentsText,
        //     uploadingState: 'Writing text to booking...',
        // });
        const token = await getAccessTokenSilently({
            scope: process.env.REACT_APP_scope,
        });
        setState({
            ...state,
            uploadingState: 'Writing text to booking...',
        });

        if (documents.length > 0 && state.textToUpload !== '') {
            try {
                setProgress({
                    loaded: 5,
                    total: 100,
                });
                let document = {
                    documentToUpload: documents[0].name,
                    size: documents[0].size,
                    sk1: props.sk1,
                    textToUpload: state.textToUpload,
                };

                const permission = await axios.post(
                    '/uploadSchoolBookingDocument',
                    document,
                    {
                        baseURL: process.env.REACT_APP_API_GATEWAY,
                        timeout: 30000,
                        headers: {
                            authorization: `Bearer ${token}`,
                            'Content-Type': documents[0].type,
                        },
                    }
                );
                const headers = {
                    'Content-Type': documents[0].type,
                };
                setState({
                    ...state,
                    uploadingState: 'Uploading Document...',
                });
                console.log(JSON.stringify(permission));
                if (
                    typeof permission.data.Message.Data.uploadURL !==
                    'undefined'
                ) {
                    axios
                        .put(
                            permission.data.Message.Data.uploadURL,
                            documents[0],
                            {
                                timeout: 1000000,
                                headers: headers,
                                onUploadProgress: function (progressEvent) {
                                    setProgress({
                                        loaded: progressEvent.loaded,
                                        total: progressEvent.total,
                                    });
                                },
                            }
                        )
                        .then(() => {
                            setState({
                                ...state,
                                uploadingState: 'Completed',
                            });
                        })
                        .catch(err => {
                            console.log(err);
                            setState({
                                ...state,
                                uploadingState: 'Failed',
                            });
                            setProgress({
                                loaded: 0,
                                total: 100,
                            });
                        });
                    dispatch(
                        schoolPreBookingUpload({
                            schoolUploadText: state.textToUpload,
                            id: props.id,
                            schoolUploadDocument:
                                permission.data.Message.Data.filename,
                            user: props.user,
                        })
                    );
                } else {
                    setProgress({
                        loaded: 100,
                        total: 100,
                    });
                    dispatch(
                        schoolPreBookingUpload({
                            schoolUploadText: state.textToUpload,
                            id: props.id,
                            user: props.user,
                        })
                    );
                }
            } catch (err) {
                console.log(err);
                console.log(err.response.data.Message.Data);
                if (err.response !== undefined) {
                    setState({
                        ...state,
                        uploadingState:
                            'Failed. ' + err.response.data.Message.Data,
                    });
                } else {
                    setState({
                        ...state,
                        uploadingState: 'Failed',
                    });
                }

                setProgress({
                    loaded: 0,
                    total: 100,
                });
            }
        } else if (state.textToUpload !== '') {
            try {
                setProgress({
                    loaded: 5,
                    total: 100,
                });
                let document = {
                    sk1: props.sk1,
                    textToUpload: state.textToUpload,
                };

                const permission = await axios.post(
                    '/uploadSchoolBookingDocument',
                    document,
                    {
                        baseURL: process.env.REACT_APP_API_GATEWAY,
                        timeout: 30000,
                        headers: {
                            authorization: `Bearer ${token}`,
                            'Content-Type': 'text/json',
                        },
                    }
                );
                setState({
                    ...state,
                    uploadingState: 'Completed',
                });
                console.log(JSON.stringify(permission));
                setProgress({
                    loaded: 100,
                    total: 100,
                });
                dispatch(
                    schoolPreBookingUpload({
                        schoolUploadText: state.textToUpload,
                        id: props.id,
                        user: props.user,
                    })
                );
            } catch (err) {
                console.log(err);
                setState({
                    ...state,
                    uploadingState: 'Failed',
                });
                setProgress({
                    loaded: 0,
                    total: 100,
                });
            }
        } else {
            setState({
                ...state,
                error: true,
                errorText: 'Please enter text before submitting',
            });
        }
    };

    useEffect(() => {
        if (typeof props.uploadText !== 'undefined') {
            setState({
                ...state,
                schoolPreBookingUpload: 'complete',
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    return (
        <div>
            <Typography variant="h1" color="secondary" sx={{ m: 1 }}>
                Action Required
            </Typography>
            <Typography variant="h4" sx={{ m: 1 }}>
                Upload pre-shift documents here
            </Typography>
            <Typography variant="body" flexWrap>
                Please upload information for the substitute teacher to start
                their shift. This will help in them preparing for the class and
                enable you to identify key learning areas to focus on during the
                time they are appointed.
            </Typography>
            <form
                sx={{
                    '& > *': {
                        margin: theme => theme.spacing(1),
                    },
                }}
                noValidate
                autoComplete="off"
            >
                <LimitedTextField
                    label="Information for the Substitute Teacher"
                    data-cy="info"
                    error={state.error}
                    value={state.textToUpload}
                    width="100%"
                    updateField={bookingText}
                    textLength={5000}
                    disabled={
                        state.uploadingState === 'Completed' ||
                        state.uploadingState === 'Writing to Booking'
                    }
                    errorText={state.errorText}
                />
                {/* <TextField
                    error=
                    helperText={state.errorText}
                    id="outlined-basic"
                    label="Information for the Substitute Teacher"
                    variant="outlined"
                    fullWidth="true"
                    multiline="true"
                    rows={10}
                    value=
                    onChange={bookingText}
                    disabled={
                        state.uploadingState === 'Completed' ||
                        state.uploadingState === 'Writing to Booking'
                    }
                    sx={{ m: 1 }}
                /> */}
                {documents.length > 0 ? (
                    <Box>
                        <Typography variant="h5">Document</Typography>
                        <Typography>{documents[0].name}</Typography>
                        <Typography>
                            {(documents[0].size / 1000000).toFixed(2)} MB
                        </Typography>
                    </Box>
                ) : (
                    <Box>
                        <Typography variant="h5">
                            No Document Uploaded
                        </Typography>
                    </Box>
                )}

                {(state.uploadingState !== 'Completed' ||
                    state.uploadingState !== 'Writing to Booking') && (
                    <BookingButton
                        variant="contained"
                        component="label"
                        sx={{ m: 1 }}
                        disabled={
                            state.uploadingState === 'Completed' ||
                            state.uploadingState === 'Writing to Booking'
                        }
                    >
                        Upload File
                        <input
                            // className={classes.input}
                            id="contained-button-file"
                            data-cy="upload-file"
                            type="file"
                            onChange={fileSelectHandler}
                            hidden
                        />
                    </BookingButton>
                )}

                <BookingButton
                    variant="contained"
                    onClick={handleSubmission}
                    data-cy="submit"
                    disabled={
                        state.uploadingState === 'Completed' ||
                        state.uploadingState === 'Writing to Booking'
                    }
                    sx={{ m: 1 }}
                >
                    Submit
                </BookingButton>
                <Typography variant="body2" sx={{ m: 1 }}>
                    Progress: {state.uploadingState}
                </Typography>
                {progress.loaded !== 0 && (
                    <Box sx={{ width: '100%' }}>
                        <BorderLinearProgress
                            variant="determinate"
                            value={(progress.loaded / progress.total) * 100}
                        />
                    </Box>
                )}
            </form>
        </div>
    );
};

export default SchoolApproved;
